import { jsx } from 'panel';
export function template() {
  return jsx("div", {
    sel: '.report-header-container'
  }, jsx("div", {
    sel: '.report-header-content'
  }, jsx("div", {
    sel: '.report-header-title'
  }, this.attr("title")), jsx("div", {
    sel: '.report-header-description'
  }, this.attr("description"))), jsx("slot", null));
}